import { Injectable } from "@angular/core";
import { EdpTableContext } from "./edp-table.model";

@Injectable({
    providedIn: "root",
})
export class EdpTableService {

    contextData: EdpTableContext[] = [];


    public setContext(name: string, data: EdpTableContext) {
        this.contextData[name] = JSON.stringify(data);
    }

    public getContext(name: string): EdpTableContext {
        let contextData = new EdpTableContext();
        if (this.contextData[name]) {
            contextData = JSON.parse(this.contextData[name]);
        }
        return contextData;
    }
}
